
export class PaymentConstants {
    public static paymentMethodMaskCode = 'ALL';
    public static default = "Default";
    public static cardExpired = 'This Card is no longer valid.Please update payment information';
    public static PuertoRico = 'PR';
    public static VirginIslands = 'VI';
    public static MarshallIslands = 'MHL';
    public static BankTransfer = 'banktransfer';
    public static BankDetails = 'Bank Details';
    public static echeck ='echeck'
}





// WEBPACK FOOTER //
// ./src/app/customerservice/constants/payment.constants.ts